<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <b-card-code>
                <validation-observer ref="simpleRules">
                  <form @submit.prevent="submitForm">
                    <b-row>
                      <b-col md="6">
                        <b-form-group>
                          <label>Lead Source</label>
                          <v-select
                            v-model="leadsource"
                            label="name"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None"
                            :options="branchOptions"
                            @input="getEmployee()"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col
                        md="6"
                        v-if="
                          leadsource.name == 'Channel Partner' ||
                          leadsource.name == 'Franchise'
                        "
                      >
                        <b-form-group>
                          <label>Select {{ leadsource.name }}</label>
                          <v-select
                            v-model="employee"
                            label="name"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None"
                            :options="employeeoption"
                            @input="getUsers()"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group>
                          <label>Select Sub Employee</label>
                          <v-select
                            v-model="subemployee"
                            label="name"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None"
                            :options="subemployeeoption"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group>
                          <label>Select Date</label>
                          <flat-pickr
                            class="form-control"
                            value=""
                            :config="{
                              dateFormat: 'd/m/Y',
                              mode: 'range',
                            }"
                            placeholder="Select Date"
                            style="background-color: transparent"
                            @input="getdata($event)"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                      <b-button
                        variant="primary"
                        class="ml-2"
                        @click="searchData"
                      >
                        <feather-icon icon="SearchIcon" class="mr-50" />
                        <span class="align-middle">Search</span>
                      </b-button>
                    </div>
                  </form>
                </validation-observer>
              </b-card-code>
              <report-table :data="data" :columns="fields" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportTable from "../../../components/ReportTable.vue";
import axios from '@/components/axios';
import Table from "@/components/Table.vue";
import BCardCode from "@core/components/b-card-code";
import flatPickr from "vue-flatpickr-component";
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Form from "@/components/form/Form.vue";
import moment from "moment";
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
} from "bootstrap-vue";
const baseApi = process.env.VUE_APP_APIENDPOINT;
import vSelect from "vue-select";
export default {
  components: {
    ReportTable,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BCardCode,
    Form,
    GoodTableColumnSearch,
  },
  data() {
    return {
      branchOptions: [
        { name: "Channel Partner", id: "channelpartner" },
        { name: "Franchise", id: "franchise" },
        { name: "Admin", id: "admin" },
      ],
      leadsource: "",
      employee: "",
      employeeoption: [],
      subemployee: "",
      subemployeeoption: [],
      leadsourceOptions: [],
      startdate: "",
      enddate: "",
      result: "",
      data: "",
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem("accessToken"),
      fields: [
        {
          field: "id",
          label: "S.R. No",
          hidden: true,
          filterOptions: { enabled: true, placeholder: "Search ID" },
        },
        {
          field: "leadsource",
          label: "Lead Source",
          filterOptions: { enabled: true, placeholder: "Search Lead Source" },
        },
        {
          field: "subsource",
          label: "Sub Source",
          filterOptions: { enabled: true, placeholder: "Search Sub Source" },
        },
        {
          field: "name",
          label: "Name",
          filterOptions: { enabled: true, placeholder: "Search Name" },
        },
        {
          field: "leaddate",
          label: "Lead Date",
          filterOptions: { enabled: true, placeholder: "Search Lead Date" },
        },
        {
          field: "mobile",
          label: "Mobile",
          filterOptions: { enabled: true, placeholder: "Search Mobile" },
        },
        {
          field: "email",
          label: "Email",
          filterOptions: { enabled: true, placeholder: "Search Email" },
        },
        {
          field: "address",
          label: "Address",
          filterOptions: { enabled: true, placeholder: "Search Address" },
        },
        {
          field: "assignto",
          label: "Assign To",
          filterOptions: { enabled: true, placeholder: "Search Assign To" },
        },
      ],
      allUser: [],
    };
  },
  mounted() {
    this.getleadsource();
    this.getAllUsers();
  },
  methods: {
    async getAllUsers() {
      const request = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getUsers`,
      };
      await axios(request).then((res) => {
        this.allUser = res.data.data;
      });
    },
    async getleadsource() {
      const request = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/leadsource`,
      };
      await axios(request).then((res) => {
        this.leadsourceOptions = res.data.data.data;
      });
    },

    getdata(selectedDates) {
      this.result = selectedDates.split(" to ");
      this.startdate = this.result[0];
      this.enddate = this.result[1];
    },
    async searchData() {
      const data = {
        branch: this.leadsource.id,
        subemployee_id: this.subemployee.id,
        startdate: this.startdate,
        enddate: this.enddate,
      };
      await axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify(data),
        url: `${this.baseApi}/leadreport`,
      }).then((response) => {
        this.data = response.data.data;

        this.data.map((item) => {
          this.leadsourceOptions.map((inner) => {
            if (inner.id == item.leadsource) {
              item.leadsource = inner.name;
            }
            if (inner.id == item.subsource) {
              item.subsource = inner.name;
            }
          });
          if (
            item.leadsource == "Channel Partner" ||
            item.leadsource == "Franchise" ||
            item.leadsource == "Self" ||
            item.leadsource == "Employee"
          ) {
            this.allUser.map((inner) => {
              if (inner.id == item.subsource) {
                item.subsource = inner.name;
              }
              if (inner.id == item.assignto) {
                item.assignto = inner.name;
              }
            });
          }
        });
      });
    },
    async getEmployee() {
      this.employee = "";
      this.subemployee = "";
      this.employeeoption = [];
      this.subemployeeoption = [];
      if (this.leadsource.name == "Channel Partner") {
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/getChannelpartner`,
        };
        await axios(requestOptions)
          .then((response) => {
            this.employeeoption = response.data.data;
          })
          .catch((error) => console.log(error, "error"));
      } else if (this.leadsource.name == "Franchise") {
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/getFranchise`,
        };
        await axios(requestOptions)
          .then((response) => {
            this.employeeoption = response.data.data;
          })
          .catch((error) => console.log(error, "error"));
      } else if (this.leadsource.name == "Admin") {
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/team`,
        };
        await axios(requestOptions)
          .then((response) => {
            this.subemployeeoption = response.data.data.data;
          })
          .catch((error) => console.log(error, "error"));
      }
    },
    async getUsers() {
      this.subemployee = "";
      this.subemployeeoption = [];
      const id = this.employee.id;
      this.employeeoption.map((item) => {
        if (id == item.parent) {
          this.subemployeeoption.push(item);
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
